import { NextPage } from 'next'
import Head from 'next/head'

import ServiceHero from '~/components/organisms/ServiceHero'
import Issue from '~/components/organisms/Issue'
import Solution from '~/components/organisms/Solution'
import AdFeature from '~/components/organisms/AdFeature'

const comment = [
  '公式サイトや教室のHPをリニューアルしたい...',
  '今のページでなかなか成果が上がらない...',
  'ウェブ広告もLP制作もまとめて相談したい...',
  'ウェブ制作会社に任せたいけれど、費用が高すぎる…',
  '学習塾や教室業の業界特性が分かっている専門スタッフにお願いしたい...',
]

const strength = [
  {
    index: '01',
    title: '学習塾・教室業に特化した\nサイト・LP制作',
    description:
      'eduadには学習塾や教室業の集客のベテランが在籍しています。あなたの教室の魅力をしっかりとヒアリングした上で、生徒・保護者が通いたくなるようなウェブサイト・LPの制作をさせていただきます。一般のウェブ制作会社では「担当者が教育業界の特性を知らなかった」「教育系案件の経験が浅かった」というケースもありますが、eduadならそんな心配はありません。',
    src: '/professional.jpg',
  },
  {
    index: '02',
    title: `最低価格100,000円からのLP制作／LPO・EFOによる運用・改善までワンストップで対応`,
    description:
      'eduadなら最低価格100,000円からのリーズナブルな価格でのLP制作が可能です。制作後もLPの継続的な運用・改善を社内の担当者がワンストップで行うため高い成果が期待できます。ウェブ制作会社では「デザインに幅が持たせられない」「こだわると非常に高額になる」と両極端なケースも少なくありません。そこまでコストがかけられない、でもオリジナルの要素を盛り込みたい、などお気軽にご相談ください。',
    src: '/onestop.jpg',
  },
  {
    index: '03',
    title: 'スマホ表示にも完全対応！教室側でも簡単に更新可能！',
    description:
      'GoogleやYahoo!での検索結果で上位表示されるような、高速かつ使いやすいサイト制作を心がけています。PC・スマートフォン表示にも完全対応！教室側から校舎情報の登録やブログの更新などを行えるCMS機能も実装可能です。操作方法も簡単！しっかりレクチャーをさせていただきます。既存のサイトのリニューアルにも対応しております！',
    src: '/next.jpg',
  },
]

const title = 'eduadのウェブサイト・LP制作の流れ'

const subtitle =
  'お問い合わせをいただいた後、初回面談にて貴社の教室運営における課題、ご希望の制作内容についてヒアリングさせていただき、解決策のご提案をさせていただきます。'

const colorProps = [
  {
    color: '#00bab3',
    number: 1,
    flow: 'お打ち合わせ',
    title: 'ヒアリング・現状把握',
    description:
      'オンラインにてお打ち合わせをさせていただき、お客様の経営方針や強み、制作物についてのご要望をお伺いします。ウェブサイト・LP制作に関することはもちろん、集客や教室運営においての課題・お悩みもお伺いできればと思います。',
  },
  {
    color: '#06a0cf',
    number: 2,
    flow: '提案',
    title: '',
    description:
      'ヒアリングでご教示いただいたご要望やイメージに応じて制作物の具体案（ワイヤーフレームなど）をご提案させていただきます。',
  },
  {
    color: '#068fcf',
    number: 3,
    flow: '契約',
    title: 'ご契約',
    description:
      'ご提案内容・料金にご納得いただけましたら、ご契約の手続きを進めて参ります。',
  },
  {
    color: '#167296',
    number: 4,
    flow: '制作',
    title: '制作開始',
    description:
      '発注をいただき次第、制作を開始します。ワイヤーフレームやデザインなどを随時ご共有させていただき、修正を行いながら進めさせていただきます。※素材のご提供や掲載内容のご入稿など、ご対応いただく点がいくつかございます。',
  },
  {
    color: '#165c96',
    number: 5,
    flow: '納品',
    title: '制作物の納品',
    description:
      '制作物を納品させていただきます。LPについてはHTMLファイル、クリエイティブについては画像ファイルでの納品となります。ウェブサイトの納品手段については相談させていただきます。ドメイン取得も含めた新規サイトの立ち上げも対応可能です。',
  },
  {
    color: '#164d96',
    number: 6,
    flow: '保守',
    title: 'アフターフォロー',
    description:
      'LPについては、原則テキスト部分など軽微なものに限り、納品後１週間以内にお申し出があった場合に対応させていただきます。ウェブサイトにつきましては、細かい文言の修正・画像の差し替えや軽度のデザイン修正など対応させていただきます。',
  },
  {
    color: '#0e3296',
    number: 7,
    flow: '改善',
    title: 'LPO・EFO／運用改善',
    description:
      'A/Bテストなどの実施、ヒートマップや各数値データを元にクリエイティブ改善を進めていきます。EFOツールを導入したCV改善試作も行っておりますので、お気軽にご相談ください。。',
  },
]

const creative: NextPage = () => {
  return (
    <>
      <Head>
        <title>ウェブクリエイティブ制作・ウェブサイト構築 | eduad</title>
        <meta
          name='description'
          content='eduad-エデュアド-は教育・スクール運営に特化したウェブマーケティング支援を行うプロフェッショナル技術者集団です。マーケティング戦略に基づくクリエイティブ制作、映像・LP制作からウェブサイトの構築までワンストップで支援いたします。'
        />
      </Head>
      <ServiceHero route='creative' />
      <Issue
        title='学習塾・教室業のサイト・LP制作なら、eduadにお任せください'
        comment={comment}
      />
      <AdFeature
        title='eduadのウェブサイト・LP制作の特長'
        strength={strength}
      />
      <Solution title={title} subtitle={subtitle} colorProps={colorProps} />
    </>
  )
}

export default creative
